import { useQueryClient } from "@tanstack/react-query";
import { Power } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { FEATURES, FEATURE_LABEL, useFeatures } from "@/lib/features";

const useToggle = () => {
  const qc = useQueryClient();
  return async (key, value) => {
    try {
      const { data } = await api.put("/admin/features", { data: { [key]: value } });
      qc.setQueryData(["features"], data);
      toast.success(`${FEATURE_LABEL[key]} switched ${value ? "on" : "off"}`);
    } catch (err) { toast.error(formatApiError(err)); }
  };
};

export const FeatureOff = ({ k, isOwner }) => {
  const toggle = useToggle();
  return (
    <div className="ad-card feature-off" data-testid={`feature-off-${k}`}>
      <Power size={22} />
      <h2>{FEATURE_LABEL[k]} is switched off</h2>
      <p className="muted-sm">It's hidden on the website and here in the admin. Everything you set up is kept and comes back when it's switched on.</p>
      {isOwner ? <button className="btn gold" onClick={() => toggle(k, true)} data-testid={`feature-turn-on-${k}`}>Turn {FEATURE_LABEL[k]} on</button>
        : <p className="muted-sm">Ask the spa owner to switch it on in Settings → Features.</p>}
    </div>
  );
};

export const FeaturesCard = () => {
  const f = useFeatures();
  const toggle = useToggle();
  if (!f) return null;
  return (
    <div className="ad-card pp-form" data-testid="features-card">
      <h3>Features</h3>
      <p className="muted-sm">Switch off anything you're not ready to use. It disappears from the website and shows as “Off” in the admin menu. Nothing is deleted — switch it back on any time.</p>
      <div className="ft-list">
        {FEATURES.map(([k, label, desc]) => (
          <label key={k} className={`ft-row ${f[k] ? "" : "off"}`} data-testid={`feature-row-${k}`}>
            <span><strong>{label}</strong><small>{desc}</small></span>
            <input type="checkbox" role="switch" className="ft-switch" checked={f[k]} onChange={(e) => toggle(k, e.target.checked)} data-testid={`feature-switch-${k}`} />
          </label>
        ))}
      </div>
    </div>
  );
};
